<template>
    <div class="map">
    <div class="google-map" id="map"></div>
    </div>
</template>

<script>
import firebase from 'firebase'
import db from '@/firebase/init'

export default {
    name: 'GMap',
    data(){
        return {
         lat: 53,
         lng: -2
        }
    },
    //create the map inside the renderMap method.
    methods: {
        renderMap(){
         const map = new google.maps.Map(document.getElementById('map'), {
             center: {lat: this.lat, lng: this.lng },
             zoom: 6,
             maxZoom: 15,
             minZoom: 3,
             streetViewControl: false
         })
         /**get all users in the database with a valid geolocation and display on the map using a marker
         Cycle through all documents and get each document's data */
         db.collection('users').get().then(users => {
             users.docs.forEach(doc => {
                 let data = doc.data()
                 if(data.geolocation){
                     let marker = new google.maps.Marker({
                         position: {
                             lat: data.geolocation.lat,
                             lng: data.geolocation.lng
                         },
                         map
                     })
                     // add click event to marker. and redirect users to profiles of the user in that location.
                     marker.addListener('click', () => {
                         this.$router.push({name: 'ViewProfile', params: {id: doc.id}})
                     })
                 }
             })
         })
        }
    },
    //Render the Google map in the mounted hook (after DOM is mounted)
    mounted (){
     //Get current user
     let user = firebase.auth().currentUser
          
     /**Get user geolocation
      * If geolocation api exists on the user browser, find out the users location,
      * It runs asynchronously, so have 3 call back functions: position, error and an object.
      */
     if(navigator.geolocation){
         navigator.geolocation.getCurrentPosition(pos => {
             this.lat = pos.coords.latitude
             this.lng = pos.coords.longitude

             //find the user record and then update geocoords in firebase
            db.collection('users').where('user_id', '==', user.uid).get()
            .then(snapshot => {
                snapshot.forEach((doc) => {
                    db.collection('users').doc(doc.id).update({
                        geolocation: {
                            lat: pos.coords.latitude,
                            lng: pos.coords.longitude
                        }
                    })
                })
            }).then (() => {
             this.renderMap()
            })

         }, (err) => {
        console.log(err)
        this.renderMap()    
         }, { maximumAge: 6000, timeout: 3000 }
         )
     }else {
         //Position center by default values
         this.renderMap()
     }
     
    }
}
</script>

<style>
.google-map{
    width: 100%;
    height: 100%;
    margin: 0 auto;
    background: #fff;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
}
</style>





// WEBPACK FOOTER //
// src/components/home/GMap.vue